import { useQuery } from "@tanstack/react-query";
import useFetch from "../lib/useFetch";
import { IPaginatedResponse, ISeederOrder } from "../types/seederOrders";

const API = process.env.REACT_APP_API;

interface UseSeederOrdersParams {
  urbanPartnerId?: number;
  fairId?: number;
}

const useSeederOrders = (params?: UseSeederOrdersParams) => {
  const fetch = useFetch();

  const queryParams = new URLSearchParams();
  if (params?.urbanPartnerId) {
    queryParams.append("urban_partner", params.urbanPartnerId.toString());
  }
  if (params?.fairId) {
    queryParams.append("fair", params.fairId.toString());
  }

  const queryString = queryParams.toString();
  const url = `${API}/api/semeadora/orders/${queryString ? `?${queryString}` : ""}`;

  return useQuery({
    queryKey: ["seeder-orders", params],
    queryFn: () => {
      return fetch(url, {
        method: "GET",
      }) as Promise<IPaginatedResponse<ISeederOrder>>;
    },
  });
};

export default useSeederOrders;
